<template>
  <div class="fill-height">
    <v-container class="fill-height">
      <v-row align="center" class="fill-height" justify="center">
        <div class="register elevation-15">
          <h3 class="font-weight-bold text-center py-3 black--text">
            비밀번호 입력
          </h3>

          <v-form class="pa-3 text-center" ref="form">
            <v-text-field
              :rules="passwordRules"
              class="pl-3 pr-3"
              label="Password"
              prepend-icon="mdi-lock"
              @keyup.enter="isOkayCheck"
              required
              type="password"
              v-model="member.password"
            >
            </v-text-field>

            <p class="mt-3 mb-0 black--text">{{ warningMsg }}</p>
            <br />
            <v-btn @click="isOkayCheck" class="mt-3" color="indigo" outlined>
              SUBMIT
            </v-btn>
          </v-form>
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Spinner from "../components/Spinner";
import { router } from "../router/index";

export default {
  name: "Resister",
  data() {
    return {
      dialog: false,
      member: {
        password: "",
      },
      validatePassword: "",
      validatePasswordRules: [
        (v) => v === this.member.password || "비밀번호가 맞지 않습니다..",
      ],
    };
  },
  computed: {
    emailRules() {
      return this.$store.state.common.emailRules;
    },
    passwordRules() {
      return this.$store.state.common.passwordRules;
    },
    nameRules() {
      return this.$store.state.common.nameRules;
    },
    warningMsg() {
      return this.$store.state.common.warningMsg;
    },
  },
  methods: {
    isOkayCheck() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("IS_OKAY_CHECK", this.member);
      }
    },
  },
};
</script>

<style scoped>
@media (min-width: 700px) {
  .register {
    width: 400px !important;
  }
}

.register {
  background-color: white;
  border-radius: 8px;
  width: 80%;
  border: white 1px solid;
  padding: 20px;
}
</style>
